import { useTranslation } from "react-i18next";

import { ProgressBarTitleProps } from "./types";

const ProgressBarTitle = ({ status }: ProgressBarTitleProps) => {
    const { t } = useTranslation();

    return t(`Dashboard##tasks##status##${status}`);
};

export default ProgressBarTitle;
